<template>
  <div class="recipe">
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="main-content">
      <div class="recipe-list-container">
        <div class="section-header text-center mobile-hide">
          <h2>{{ $t('recipesForYou') }}</h2>
        </div>
        <div class="filters-toolbar-wrapper">
          <div class="filters-toolbar__item-child">
            <p>{{ $t('sortBy') }} :</p>
            <el-select v-model="dishType" v-bind:placeholder="$t('dishType')" value="" @change="updateDishType">
              <el-option
                v-for="item in dishTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
            <el-select v-model="difficulty" v-bind:placeholder="$t('difficulty')" value="" @change="updateDifficulty">
              <el-option
                v-for="item in difficultyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </div>
        </div>
        <ul>
          <li v-for="(item,index) in this.$store.state.recipe.recipes" :key='index' @click="goToRecipeDetail(item.recipe_id)">
            <div class="recipe-image">
              <img v-if="item.image_file" :src="item.image_file" alt="">
              <img v-else src="../../assets/img/coming.png" alt="">
            </div>
            <div class="recipe-text">
             <p><strong>{{item.title}}</strong></p>
             <p class="mobile-hide">
               <span v-html="item.rich_text_description"></span>
             </p>
            </div>
          </li>
        </ul>
        <pagination
          :totalPages="pages"
          :total="count"
          :currentPage="currentPage"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from '../../components/breadcrumb';
import pagination from "../../components/pagination";

export default {
  name: "recipes",
  components: {
    breadcrumb,
    pagination,
  },
  data() {
    return {
      path2: this.$t('recipes'),
      currentPage: 1,
      // filter for difficulty and dishType, hard code now, later can get from api when SCM done
      difficulty: '',
      difficultyOptions: [
        { value: '0', label: 'All' },
        { value: '2', label: 'Easy' },
        { value: '3', label: 'Moderate' },
        { value: '4', label: 'Hard'},
      ],
      dishType: '',
      dishTypeOptions: [
        { value: '1',label: 'All' },
        { value: '2',label: 'Beef' },
        { value: '3', label: 'Pork' },
        { value: '4', label: 'Poultry' },
        { value: '5', label: 'Seafood' },
        { value: '6', label: 'Vegetarian' },
        { value: '7', label: 'Appetizers & Desserts' },
      ],
    }
  },
  methods: {
    ...mapActions('recipe', ['fetchRecipes, fetchRecipeDetail']),
    ...mapMutations('recipe', ['updateRecipeId']),
    ...mapMutations('navbar', ['mobileDevice']),

    goToRecipeDetail(id) {
      this.updateRecipeId(id);
      this.$router.push(`/recipe/${id}`);
    },
    updateDishType(value) {
      this.dishType = value;
      this.updateFilter();
    },
    updateDifficulty(value) {
      this.difficulty = value;
      this.updateFilter();
    },
    updateFilter() {
      const page = this.currentPage || 1;
      let dishType = ''
      let difficulty = ''
      if (this.dishType && this.dishType !== 'All' ) {
        dishType = this.dishType;
      }
      if (this.difficulty && this.difficulty !== 'All' ) {
        difficulty = this.difficulty;
      }
      this.$store.dispatch('recipe/filterRecipes', [page, dishType, difficulty]);
    },
    onPageChange(page) {
      this.currentPage = page;
      this.updateFilter();
      window.scrollTo(0, 0);
    }
  },
  computed: mapState({
    mobile: state => state.navbar.mobile,
    pages: state => state.recipe.recipesPaginate,
    count: state => state.recipe.recipesCount,
  }),
  beforeMount() {
    if (window.screen.width <= 500) {
      this.mobileDevice(true);
    } else {
      this.mobileDevice(false);
    }
  },
  mounted() {
    this.$store.dispatch('recipe/fetchRecipes');
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/recipe.less";
</style>



// WEBPACK FOOTER //
// src/view/Recipe/recipes.vue